exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#tie[data-v-83a13534] {\n  position: fixed;\n  background: white;\n  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.3);\n  left: 0;\n  right: 0;\n  z-index: 20;\n}\n.tie-border-info[data-v-83a13534] {\n  border-top: 3px solid #0176de;\n}\n.tie-border-warning[data-v-83a13534] {\n  border-top: 3px solid #fec60d;\n}\n.tie-border-error[data-v-83a13534] {\n  border-top: 3px solid #f24f4f;\n}\n", ""]);

// exports
